module.exports = __webpack_public_path__ + "img/project_icon_five.8ccd6f46.png";